export default {
    Plants: "forecastingPlantData",
    Weather: "forecastingWeatherData",
    Crops: "forecastingCrops",
    Varieties: "forecastingVarieties",
    Forecasts: "forecastingForecasts",
    Notes: "forecastingNotes",
    UnsentForecasts: "forecastingUnsentForecasts",
    NoteAlertCategories: "noteAlertCategories",
    UnsyncedNotes: "forecastingUnsyncedNotes",
    UnsentCropVarieties: "forecastingUnsentCropVarieties",
    FinancialYearCalendars: "forecastingFinancialYearCalendars",
    NuPointSprays: "forecastingNuPointSprays"
}